import React from 'react';
import PropTypes from 'prop-types';

const StripeInput = ({
  className,
  component: Component,
  inputRef,
  onBlur,
  onChange,
  onFocus,
  placeholder,
}) => {
  const [mountNode, setMountNode] = React.useState(null);

  React.useImperativeHandle(
    inputRef,
    () => ({
      focus: () => mountNode.focus(),
    }),
    [mountNode],
  );

  return (
    <Component
      placeholder={placeholder}
      className={className}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      onReady={setMountNode}
    />
  );
};

StripeInput.propTypes = {
  className: PropTypes.string,
  component: PropTypes.func.isRequired,
  inputRef: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default StripeInput;
